import * as React from 'react';
import { SectionGrammarRelated } from './components/SectionGrammarRelated';
import {
  ElementAuthorTop,
} from './components/ElementAuthorTop';
import {
  ElementAuthorBottom,
} from './components/ElementAuthorBottom';
import { SideInfoReadingInfoNotAuth } from './components/SideInfoReadingInfoNotAuth';
import { ExerciseCardBlogGrammar } from '../home-page/components/ExerciseCardBlogGrammar';
import { TheoryCardBlogGrammar } from '../home-page/components/TheoryCardBlogGrammar';
import { GrammarDetailLessonBase } from './components/core-blog-editor/GrammarDetailLesson';
import { StudentDoTestGrammarBlogTemplate } from './components/StudentDoTestGrammarBlogTemplate';
import {
  StudentDoTestGrammarLandingTemplate,
} from './components/StudentDoTestGrammarLandingTemplate';
import { formatDate } from '@doltech/utils/lib/date';
import {
  findGrammarUrlByTemplateTypeId, getExerciseOrTheoryByTopicId,
  getFinalUrlGrammar,
} from '../shared/utils';
import { GrammarTemplateTypeEnum } from '../shared/constants';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { MONTH_NAME_FORMAT } from '@doltech/utils/lib/constants';
import { GrammarTopicTypeContent } from '@doltech/domains/grammar/lib/shared/utils/constants';
import { useAuthorizeUser } from '../home-page/hooks/useAuthorizeUser';
import {
  SideInfoReadingInfo,
} from './components/SideInfoReadingInfo';
import {
  CardFinishConfirm,
} from './components/CardFinishConfirm';
import {
  BreadcrumbGroupGrammar,
} from './components/core-blog-editor/BreadcrumbGroupGrammar';
import {
  useUpdateReadingTime,
} from './hooks/useUpdateReadingTime';

const EMPTY = '-';

interface GrammarLandingTheoryDetailPagePropsProps {
  data?: any;
  otherUrlInfo?: any;
  urlInfo?: any;
}

export const GrammarLandingTheoryDetailPage = (props: GrammarLandingTheoryDetailPagePropsProps) => {
  const { otherUrlInfo, data } = props;
  const { relatedBlogs, relateTopics, blogPageData, users } = data || {};
  const { onUserLogin, onNeedToAuthorizeUser } = useAuthorizeUser();
  useUpdateReadingTime(blogPageData?.id);

  const rawTopicUrl = findGrammarUrlByTemplateTypeId(otherUrlInfo, GrammarTemplateTypeEnum.LANDING_GRAMMAR_THEORY);
  const rawAuthorUrl = blogPageData?.grammarAuthor?.url;
  const currentUrl = getFinalUrlGrammar(blogPageData?.url);
  const topicName = GrammarTopicTypeContent[blogPageData?.grammarTopic?.topicId];

  return (
    <StudentDoTestGrammarLandingTemplate
      blogPreview={
        <StudentDoTestGrammarBlogTemplate
          grammarBreadcrumb={
            <BreadcrumbGroupGrammar
              breadcrumbLv1={{
                label: 'Home page',
                url: getFinalUrlGrammar(''),
              }}
              breadcrumbLv2={{
                label: 'Lý thuyết Ngữ pháp',
                url: getFinalUrlGrammar(rawTopicUrl),
              }}
              breadcrumbLv3={
                blogPageData?.dol?.hasBreadcrumb ?
                  {
                    label: blogPageData?.dol?.breadcrumbName,
                    url: getFinalUrlGrammar(blogPageData?.dol?.breadcrumbUrl),
                  } :
                  {
                    label: topicName,
                    url: getExerciseOrTheoryByTopicId(getFinalUrlGrammar(rawTopicUrl), blogPageData?.grammarTopic?.topicId),
                  }
              }
            />
          }
          grammarBlog={
            <GrammarDetailLessonBase
              data={blogPageData?.seoPageTheory}
              dol={blogPageData?.dol}
              onNeedToSignIn={onNeedToAuthorizeUser}
              renderUserInfo={
                <SideInfoReadingInfo
                  users={users}
                  type="theory"
                  statusPosition="top"
                  hasTimeCounter={false}
                />
              }
              renderTopAuthor={
                <ElementAuthorTop
                  name={blogPageData?.grammarAuthor?.name}
                  avatarUrl={s3ToCDN(blogPageData?.grammarAuthor?.avatar?.path)}
                  date={blogPageData?.lastModifiedAt ? formatDate(blogPageData?.lastModifiedAt, MONTH_NAME_FORMAT) : EMPTY}
                  topic={topicName}
                  topicId={blogPageData?.grammarTopic?.topicId}
                  onCopyLink={() => currentUrl}
                  authorUrl={getFinalUrlGrammar(rawAuthorUrl)}
                  topicUrl={getFinalUrlGrammar(rawTopicUrl)}
                  disabledAuthor={!rawAuthorUrl || blogPageData?.grammarAuthor?.unListed}
                  disabledTopic={!rawTopicUrl}
                  currentUrl={currentUrl}
                  pageId={blogPageData?.id}
                />
              }
              renderBottomAuthor={
                <ElementAuthorBottom
                  name={blogPageData?.grammarAuthor?.name}
                  avatarUrl={s3ToCDN(blogPageData?.grammarAuthor?.avatar?.path)}
                  description={blogPageData?.grammarAuthor?.shortDescription}
                  authorUrl={getFinalUrlGrammar(rawAuthorUrl)}
                />
              }
              detailInfo={
                <SideInfoReadingInfoNotAuth
                  users={users}
                  title={blogPageData?.name}
                  onSignUp={onUserLogin}
                />
              }
            />
          }
          grammarAction={
            <CardFinishConfirm
              onClick={onNeedToAuthorizeUser}
            />
          }
          relatedGrammar={
            <SectionGrammarRelated
              title="BÀI TẬP ĐI KÈM"
              data={relatedBlogs}
              renderData={(grammar) => (<ExerciseCardBlogGrammar data={grammar} isShowImage/>)}
            />
          }
          sameTopicGrammar={
            <SectionGrammarRelated
              title="LÝ THUYẾT CÙNG CHỦ ĐỀ"
              data={relateTopics}
              renderData={(grammar) => (<TheoryCardBlogGrammar data={grammar} isShowImage/>)}
              hasButton
              buttonLabel="Xem thêm Lý thuyết"
              lessonListUrl={getFinalUrlGrammar(rawTopicUrl)}
            />
          }
        />
      }
      detailInfo={
        <SideInfoReadingInfoNotAuth
          users={users}
          title={blogPageData?.name}
          onSignUp={onUserLogin}
        />
      }
    />
  );
};
